import React from "react";

const ActivationToggle = ({ isActive, onToggle, isToggling, t }) => (
  <div className="form-group">
    <div className="col-lg-9 col-md-9 col-sm-12 col-12 text-left m-auto">
      <div className="form-group">
        <div className="alert alert-outline-primary fade show" role="alert">
          <div className="alert-icon">
            <i className="flaticon-information kt-font-brand" />
          </div>
          <div className="alert-text">
            {t(
              "Cette fonctionnalité permet de collecter les commentaires de vos clients sur les réseaux grâce à une intelligence artificielle. Elle nécessite une connexion internet."
            )}
          </div>
          <div className="alert-close">
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label={t("Close")}
            >
              <span aria-hidden="true">
                <i className="la la-close" />
              </span>
            </button>
          </div>
        </div>
      </div>

      <span style={{ transform: "scale(0.9,0.9)" }} className="kt-switch">
        <label>
          <input
            type="checkbox"
            checked={isActive}
            disabled={isToggling}
            onChange={onToggle}
          />
          <span />
          <div
            style={{
              fontSize: "16px",
              whiteSpace: "nowrap",
              marginTop: "6px",
              marginLeft: "14px",
            }}
          >
            {t("Veuillez cocher pour confirmer l'utilisation")}
          </div>
        </label>
      </span>
    </div>
  </div>
);

export default ActivationToggle;
